import { Modal, Span } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

interface IProps {
  unsavedChangesModalOpen: boolean;
  redirectUrl: string;
  setUnsavedChangesModalOpen: (isOpen: boolean) => void;
}

export const RcsTemplateEditorUnsavedChangesModal = ({
  redirectUrl,
  unsavedChangesModalOpen,
  setUnsavedChangesModalOpen,
}: IProps) => {
  const { t } = useTranslation(['designs']);
  const { push } = useHistory();

  const handleClose = () => {
    setUnsavedChangesModalOpen(false);
  };

  const handleConfirm = () => {
    setUnsavedChangesModalOpen(false);
    push(redirectUrl);
  };

  return (
    <div data-testid="RcsTemplateEditorUnsavedChangesModal">
      <Modal
        heading={t('designs:designGallery.templateEditor.modals.unsavedChanges.header')}
        variation="clean"
        isOpen={unsavedChangesModalOpen}
        onCancelButtonClicked={handleClose}
        onCloseButtonClicked={handleClose}
        onOkButtonClicked={handleConfirm}
        okButtonLabel={t('designs:designGallery.templateEditor.modals.common.confirm')}
        okButtonDisabled={false}
        cancelButtonLabel={t('designs:designGallery.templateEditor.modals.common.cancel')}
      >
        <Span>{t('designs:designGallery.templateEditor.modals.unsavedChanges.message')}</Span>
      </Modal>
    </div>
  );
};
